import { Button, Text, VStack } from '@chakra-ui/react';
import Layout from '@web-app/components/Layout';
import { FC } from 'react';

interface PreCallLandingPageProps {
  organizationId?: number;
  welcomeCompanyName: string;
  onClientJoinCall: () => void;
  onProviderJoinCall: () => void;
}

/**
 * Pre-call landing page that allows patients to join directly
 * or providers to log in before joining the session.
 */
export const PreCallLandingPage: FC<PreCallLandingPageProps> = ({
  welcomeCompanyName,
  onClientJoinCall,
  onProviderJoinCall,
}) => {
  return (
    <Layout>
      <VStack
        w={['90%', '400px']}
        gap="2rem"
        data-testid="pre-call-landing-page"
      >
        <VStack
          py={['2rem', '2rem', '3rem']}
          bg="bg.default"
          borderRadius="1rem"
          width="100%"
        >
          <Text
            fontFamily="heading"
            as="h1"
            fontSize="36px"
            lineHeight="38px"
            color="text.brand"
            textAlign="center"
            w="180px"
          >
            Welcome to
          </Text>
          <Text
            fontFamily="heading"
            as="h1"
            fontSize="36px"
            lineHeight="38px"
            color="text.brand"
            textAlign="center"
            w="180px"
          >
            {welcomeCompanyName}
          </Text>
          <Button
            marginTop="1rem"
            colorScheme="orange"
            data-testid="join-call-button"
            onClick={onClientJoinCall}
            w="256px"
            h="60px"
            borderRadius="16px"
          >
            Join call as patient
          </Button>
        </VStack>
        <VStack
          py={['2rem', '2rem', '3rem']}
          bg="bg.default"
          borderRadius="1rem"
          width="100%"
        >
          <Text
            as="p"
            fontSize="1.5rem"
            lineHeight="2rem"
            marginBottom="1rem"
            color="text.brand"
            textAlign="center"
            fontWeight={600}
          >
            Are you a dietitian?
          </Text>
          <Button
            variant="outline"
            colorScheme="text.brand"
            background="text.brand"
            color="white"
            h="60px"
            w="256px"
            fontWeight="bold"
            borderColor="green.150"
            onClick={onProviderJoinCall}
            borderRadius="16px"
            py={1}
          >
            Log in as provider
          </Button>
        </VStack>
      </VStack>
    </Layout>
  );
};
